import { Stack, Typography } from '@mui/material';
import CardWrapper from 'components/Common/CardWrapper';
import MuiLoader from 'components/Common/Loader';
import ProfileItemDetail from 'components/ProfileItemDetail';
import Routes from 'constants/routes';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchAuthRequest } from 'redux/slices/user/authRequestSlice';
import { AppDispatch, RootState } from 'redux/store';
import { dateFormat } from 'utils/helpers';

const StoredPaymentTokens = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const authRequest = useSelector((state: RootState) => state?.authRequest);
    const { data, loading } = authRequest;

    useEffect(() => {
        dispatch(fetchAuthRequest());
    }, [dispatch]);

    const navigationHandler = (id: any) => {
        if (!id) {
            return;
        }
        navigate(Routes.account.paymentTokenDetail.replace(':id', id));
    };
    if (loading) {
        return <MuiLoader absolute loading={loading} />;
    }

    return (
        <>
            <CardWrapper hideButton={true}>
                {data?.length ? (
                    data?.map((authResponse, index) => (
                        <Stack
                            key={index}
                            onClick={() => navigationHandler(authResponse?.id)}
                            sx={{
                                cursor: 'pointer',
                                transition: 'background-color 0.2s ease',
                                '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                },
                            }}
                        >
                            <ProfileItemDetail label={authResponse?.nickname} value={dateFormat(authResponse?.updatedAt)} />
                        </Stack>
                    ))
                ) : (
                    <Typography alignSelf={'center'}>No tokens available.</Typography>
                )}
            </CardWrapper>
        </>
    );
};

export default StoredPaymentTokens;
